import { c as _c } from "react/compiler-runtime";
import { ArrowLongRightIcon as ArrowRight } from '@heroicons/react/24/solid';
import type { GetAllCollectionsOutputDTO } from '@/backend/modules/docs/endpoints/queries/get-all-collections/output.dto';
import { Button } from '@/frontend/design-system/actions/Button';
import { Link } from '@/frontend/design-system/actions/Link';
import { TextDecorator } from '@/frontend/design-system/atoms/TextDecorator';
import { H3 } from '@/frontend/design-system/typography/Heading';
import { P2 } from '@/frontend/design-system/typography/Paragraph';
export type CollectionCardProps = {
  collection: GetAllCollectionsOutputDTO['allCollections'][number];
};
export function CollectionCard(t0) {
  const $ = _c(17);
  const {
    collection
  } = t0;
  const t1 = `/baza/${collection.slug}`;
  let t2;
  if ($[0] !== collection.gradientColor || $[1] !== collection.name) {
    t2 = <TextDecorator gradientColor={collection.gradientColor}>{collection.name}</TextDecorator>;
    $[0] = collection.gradientColor;
    $[1] = collection.name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <H3><Link href={t1}>{t2}</Link></H3>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== collection.description) {
    t4 = <P2 className="text-contentTertiary">{collection.description}</P2>;
    $[6] = collection.description;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="space-y-3">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `/baza/${collection.slug}`;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ArrowRight />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <Button plain={true} href={t6} className="w-fit self-end font-normal">Przejdź do artykułów{t7}</Button>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <div className="w-full max-w-md rounded-xl border border-borderPrimary bg-backgroundPrimary p-6 pb-4.5 shadow-md"><div className="flex h-full flex-col justify-between gap-4">{t5}{t8}</div></div>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}